module.exports = __webpack_public_path__ + "media/images/sf-brand-white-a2f7990fd24580b62edefb4686083f35.png";